function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import tasks from '@/js/tasks';
import { ROLES_LIST, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from '@/components/DialogsComponent.vue';
import searchengine_services from '@/apps/chatbots/services/search_engine_services';
export default {
  components: {
    DialogsComponent: DialogsComponent
  },
  data: function data() {
    return {
      DATAPLEX_STATES: DATAPLEX_STATES,
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      item_selected: {},
      data: [],
      data_to_filter: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      type_params: [{
        value: 'QDRANT',
        text: 'QDRANT'
      }, {
        value: 'AI_SEARCH',
        text: 'AI_SEARCH'
      }, {
        value: 'TYPESENSE',
        text: 'TYPESENSE'
      }],
      rules: {
        name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 100 || 'Menor o igual a 100 caracteres.';
        }],
        description: [function (v) {
          return v === '' || v === undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active'])), {}, {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers: function headers() {
      return [{
        value: 'type',
        text: this.traductor('chatbots.search_engine.metadata.type')
      }, {
        value: 'name',
        text: this.traductor('chatbots.search_engine.metadata.name')
      }, {
        value: 'description',
        text: this.traductor('chatbots.search_engine.metadata.description')
      }, {
        value: 'actions',
        text: this.traductor('chatbots.search_engine.metadata.actions')
      }];
    }
  }),
  created: function created() {
    this.listSearchEngine();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    formatDate: function formatDate(data) {
      if (data) return data ? data.substring(0, 19).replace('T', ' ') : '';
      return '';
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onSearch: function onSearch() {
      var _this = this;
      this.data = Object.assign([], this.data_to_filter);
      if (this.filters.name) {
        this.data = this.data.filter(function (x) {
          return x.name.toUpperCase().indexOf(_this.filters.name.toUpperCase()) !== -1;
        });
      }
      if (this.filters.description) {
        this.data = this.data.filter(function (x) {
          return x.description.toUpperCase().indexOf(_this.filters.description.toUpperCase()) !== -1;
        });
      }
    },
    onLimpiar: function onLimpiar() {
      this.data = Object.assign([], this.data_to_filter);
      this.resetFilters();
    },
    resetFilters: function resetFilters() {
      this.filters = {};
      this.listSearchEngine();
    },
    listSearchEngine: function listSearchEngine() {
      var _this2 = this;
      searchengine_services.getAll().then(function (response) {
        console.log(response);
        if (response.success) {
          _this2.data = response.data;
          _this2.data_to_filter = Object.assign([], _this2.data);
          _this2.pagination.total = response.data.length;
        }
      });
    },
    onSaveBot: function onSaveBot() {
      var _this3 = this;
      searchengine_services.create(this.item_selected).then(function (response) {
        if (response.success) {
          tasks.toast.success('El registro se guardó correctamente.');
          _this3.$refs['DIALOG_CRUD_BOT'].onClose();
          _this3.resetFilters();
        } else {
          tasks.toast.warning('No se pudo guardar el registro.');
        }
      });
    },
    onUpdateBot: function onUpdateBot() {
      var _this4 = this;
      searchengine_services.update(this.item_selected.id, this.item_selected).then(function (response) {
        if (response.success) {
          tasks.toast.success('El registro se guardó correctamente.');
          _this4.$refs['DIALOG_CRUD_BOT'].onClose();
          _this4.resetFilters();
        } else {
          tasks.toast.warning('No se pudo guardar el registro.');
        }
      });
    },
    goCreatePage: function goCreatePage() {
      this.edit = false;
      this.view = false;
      this.item_selected = {};
      this.$refs['DIALOG_CRUD_BOT'].onOpen();
    },
    onEditProject: function onEditProject(item) {
      this.edit = true;
      this.view = false;
      this.item_selected = Object.assign({}, item);
      this.$refs['DIALOG_CRUD_BOT'].onOpen();
    },
    onViewProject: function onViewProject(item) {
      this.edit = false;
      this.view = true;
      this.item_selected = Object.assign({}, item);
      this.$refs['DIALOG_CRUD_BOT'].onOpen();
    },
    onRemoveProject: function onRemoveProject(item) {
      this.item_selected = Object.assign({}, item);
      this.$refs['DIALOG_REMOVE_BOT'].onOpen();
    },
    onConfirmRemoveProject: function onConfirmRemoveProject(value) {
      var _this5 = this;
      if (value) {
        searchengine_services.delete(this.item_selected.id).then(function (response) {
          if (response.success) {
            tasks.toast.success('Se ha eliminado correctamente el registro.');
            _this5.onLimpiar();
            _this5.$refs['DIALOG_REMOVE_BOT'].onClose();
          } else {
            tasks.toast.error('No se ha podido eliminar el registro.');
          }
        });
      } else {
        this.$refs['DIALOG_REMOVE_BOT'].onClose();
      }
    }
  }
};